import React from 'react';
import PropTypes from 'prop-types';
import { ExportButton, RefreshButton } from './';

/**
 * HeaderControls Component
 *
 * Renders header control buttons for exporting data and refreshing content.
 * Utilizes React.memo to prevent unnecessary re-renders when props remain unchanged.
 *
 * @param {Object} props - Component properties.
 * @param {Function} props.onExport - Callback for export button click event.
 * @param {Function} props.onRefresh - Callback for refresh button click event.
 * @returns {JSX.Element} The rendered header control buttons.
 */
const HeaderControls = ({ onExport, onRefresh }) => {
  return (
    <div className="flex items-center space-x-4">
      <ExportButton
        exportOptions={[
          { format: 'csv', label: 'Export as CSV' },
          { format: 'excel', label: 'Export as Excel' },
        ]}
        onExport={onExport}
      />
      <RefreshButton onClick={onRefresh} />
    </div>
  );
};

HeaderControls.propTypes = {
  onExport: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

export default React.memo(HeaderControls);
